import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    estimatedRepaymentsTitle: {
        id: '_.rbl_dashboard.approved_estimated_repayments_title',
        defaultMessage:
            'Based on your revenue now, here’s what your monthly repayments could look like. '
    },
    currentMonthlyRevenue: {
        id: '_.rbl_dashboard.approved_estimated_repayments_monthly_revenue',
        defaultMessage: 'Your monthly eligible sales revenue:'
    },
    monthlyRevenueExplanation: {
        id: '_.rbl_dashboard.approved_estimated_repayments_monthly_revenue_explanation',
        defaultMessage:
            '(the average of your last three months’ eligible sales)'
    },
    estimatedRepayments: {
        id: '_.rbl_dashboard.approved_estimated_repayments_amount',
        defaultMessage: 'Estimated monthly repayments ({percentage}):'
    },
    timeToRepay: {
        id: '_.rbl_dashboard.approved_estimated_time_to_repay',
        defaultMessage: 'Time to repay:'
    },
    repaymentInMonths: {
        id: '_.rbl_dashboard.approved_estimated_repayment_in_months',
        defaultMessage: '{months} months'
    },
    estimatedTipInfo: {
        id: '_.rbl_dashboard.approved_estimated_tip_info',
        defaultMessage:
            'This is based on your revenue over the past 3 months - your performance will affect how long you repay for. '
    }
});
